<template>
  <div class="envio-search">
    <div class="search-box">
      <input
        type="text"
        v-model="searchTerm"
        placeholder="Buscar por expendeduría, máquina o descripción..."
        @input="handleSearch"
        class="search-input"
      >
      <span v-if="loading" class="loading-indicator">⌛</span>
    </div>

    <div v-if="error" class="error-message">
      {{ error }}
    </div>

    <div v-if="!loading && sortedEnvios.length === 0" class="no-results">
      No se encontraron envios
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, ref, watch } from 'vue';
import { useEnviosStore } from '@/stores/useEnvioStore';
import { storeToRefs } from 'pinia';

const envioStore = useEnviosStore();
const { sortedEnvios, loading, error } = storeToRefs(envioStore);
const searchTerm = ref('');

// Debounce para búsqueda
let searchTimeout: number;

const handleSearch = () => {
  clearTimeout(searchTimeout);
  searchTimeout = setTimeout(() => {
    envioStore.setSearchTerm(searchTerm.value);
  }, 300);
};

</script>

<style scoped>
.search-box {
  position: relative;
  margin-bottom: 2rem;
}

.search-input {
  width: 100%;
  padding: 0.8rem;
  border: 2px solid #ccc;
  border-radius: 25px;
  font-size: 1rem;
  transition: all 0.3s ease;
}

.search-input:focus {
  outline: none;
  border-color: #2196f3;
  box-shadow: 0 0 8px rgba(33, 150, 243, 0.3);
}

.loading-indicator {
  position: absolute;
  right: 15px;
  top: 50%;
  transform: translateY(-50%);
}

.envio-list {
  display: grid;
  gap: 1rem;
}

.envio-item {
  background: #fff;
  border-radius: 8px;
  padding: 1.5rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: transform 0.2s ease;
}

.envio-item:hover {
  transform: translateY(-2px);
}

.envio-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
}

.envio-date {
  color: #666;
  font-size: 0.9rem;
}

.error-message {
  color: #ff4444;
  padding: 1rem;
  border-radius: 4px;
  margin: 1rem 0;
  background: #ffebee;
}

.no-results {
  text-align: center;
  color: #666;
  padding: 2rem;
}
</style>